import React from 'react';
import './index.css';
import ReactDom from 'react-dom';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import Landing from './components/Landing';
import Decision from './components/Decision';
import Lucky from './components/Lucky';
import Prophecy from './components/Prophecy';

const Index = ()=>{
    return(
        <Router>
            <Switch>
                <Route path="/" exact component={Landing} />
                <Route path="/decision" component={Decision} />
                <Route path="/lucky" component={Lucky}/>
                <Route path="/prophecy" component={Prophecy} />
            </Switch>
        </Router>
    );
}

ReactDom.render(<Index />, document.querySelector("#root"));